import { Component, inject } from '@angular/core';
import { StandardPageLayoutComponent } from '@layouts/pages/standard-page-layout/standard-page-layout.component';
import { WhatsOnComponent } from '@features/components/events/whats-on/whats-on.component'
import { HomePageService } from './home-page.service';

@Component({
  selector: 'app-home-page',
  imports: [StandardPageLayoutComponent, WhatsOnComponent],
  templateUrl: './home-page.component.html',
  providers: [HomePageService]
})
export class HomePageComponent {

  private homePageService = inject(HomePageService);

}
